import { create } from 'zustand';

import { DialogProductReplace } from '@components/Alert/templates/DialogProductReplace';
import { useRefAlert } from "@components/Alert";
import { MutableRefObject } from 'react';

interface NewProduct {
  description: string,
  discount: number,
}


interface AddItemOverwriteAlert {
  ref: MutableRefObject<useRefAlert | undefined> | undefined,
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onSuccessCallback: () => void;
  onFailCallback: () => void;
  setOnSuccessCallback: (on: () => {}) => void;
  setOnFailCallback: (on: () => {}) => void;
  newProduct: NewProduct
  text: string | React.ReactElement,
  setNewProduct: (newP: NewProduct) => void,
  setRef: (ref: MutableRefObject<useRefAlert | undefined>) => void,
}

export const useAddItemOverwriteAlert = create<AddItemOverwriteAlert>((set, get) => ({
  isOpen: false,
  text: '',
  ref: undefined,
  onSuccessCallback: () => { },
  onFailCallback: () => { },
  setOnSuccessCallback: (onSuccessCallback) => set({ onSuccessCallback }),
  setOnFailCallback: (onFailCallback) => set({ onFailCallback }),
  setRef: (ref) => set({ ref }),
  newProduct: { description: '', discount: 0 },
  onOpen: () => {
    set({ isOpen: true })
    get().ref?.current?.show()
  },
  onClose: () => {
    set({ isOpen: false })
    get().onFailCallback()
  },
  setNewProduct: (newProduct: NewProduct) => {
    const text = DialogProductReplace(
      newProduct.description,
      newProduct.discount
    );
    set({ text, newProduct })
  },
}));
